<template>

  <template v-if="items && items.length && (!onAward || items.length > 0)">
    <transition-group
      name="block-slide-in"
      :style="{ '--total': items.length }"
    >
    <template  v-for="(item, index) in items" :key="index">
      <component
      class="custom-folder-card"
      v-if="itemChildren.length === 0"
        :is="getFolderName(item.idBlockType)"
        :item="item"
        :index="index"
        @navigate="handleNavigation" 
      />
    </template>
      <template v-if="itemChildren.length > 0">
      <template v-for="(item, index) in itemChildren" :key="index">
<!--         <CheckInOutCard
            :item="item"
            :index="index"
            :timer="timer"
            :isCheckInDisabled="isCheckInDisabled"
            :isCheckOutDisabled="isCheckOutDisabled"
            @check-in="handleCheckIn"
            @check-out="handleCheckOut"
          /> -->
     <ion-card
     v-if="item.idBlockType === 7"
  :style="{ '--i': i }"
  class="custom-checkinout-card"
>
  <div class="badge">
   <!-- 
    <span class="badge-text">{{ item.randomPercentage }}%</span> -->
  </div >
  <ion-card-header>
    <div class="title">
      <ion-card-title>
        <span class="text-20">{{ item.nome }}</span>
        <div class="timer">{{ timer }}</div>
        <div class="checkinout-button-container">
        <ion-button
          expand="block"
          style="width: 100%"
          :disabled="isCheckInDisabled"
          @click="handleCheckIn"
          :class="{ 'btn-check-in': !isCheckInDisabled, 'btn-disabled': isCheckInDisabled }"
        >
          Check In
        </ion-button>
        <ion-button
          expand="block"
          style="width: 100%"
          :disabled="isCheckOutDisabled"
          @click="handleCheckOut"
          :class="{ 'btn-check-out': !isCheckOutDisabled, 'btn-disabled': isCheckOutDisabled }"
        >
          Check Out
        </ion-button>
      </div>
      </ion-card-title>
    </div>
  </ion-card-header>
</ion-card>
<LearningCard :item="item" />
<SignatureCard :item="item" />
<InductionCard :item="item" :whappyClientConfig="whappyClientConfig" />
<SurveyList
  :item="item"
  :surveys="surveys"
  :showList1="showList1"
  :showList2="showList2"
/>
  </template>
</template>
 </transition-group> 
  </template>
</template>

<script>
import FolderCard from "./journey-cards/FolderCard.vue";
import ChekInOutCard from "./journey-cards/ChekInOutCard.vue";
import CampaignService from "../common/mixins/Campaign";
import LearningCard from "./journey-cards/LearningCard.vue";
import SignatureCard from "./journey-cards/SignatureCard.vue";
import SurveyList from "./journey-cards/SurveyList.vue";
import InductionCard from "./journey-cards/InductionCard.vue";
import { IonCard, IonCardHeader, IonCardTitle } from "@ionic/vue";
import ApiService from "../common/service.api";
import { useStore } from "vuex";
import PrenotaAppuntamento from "../views/pk_views/components/PrenotaAppuntamento.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";
import SurveyCard from "../views/pk_views/components/SurveyCard.vue";
import { CircleProgressBar } from 'circle-progress.vue';
import { useSurveys } from "../composables/useSurveys";
import KpiGraph from "../components/KpiGraph.vue";
const {  mySurveys, getMySurveys } = useSurveys();
export default {
  name: "CampaignJourneyMenuFolders",
  data() {
    return {
      title: '',
      isLoading: false,
      items: [],
      itemChildren: [] ,
      showList1: false,
      showList2: false,
      lastActionType: null,
      campaignId: null,
      isCheckInDisabled: false,
      isCheckOutDisabled: true,
      timer: "00:00:00",
      timerInterval: null,
      showTimer: false,
      surveys: [],
      themeConfig: {},
    };
  },
  components: {  LearningCard, SurveyList, ChekInOutCard,  InductionCard, FolderCard, SignatureCard, IonCard, IonCardHeader, IonCardTitle, VideoPlayer, PrenotaAppuntamento, CircleProgressBar, SurveyCard, KpiGraph },
  mixins: [CampaignService],
  methods: {
    async getThemeConfig() {
  const companyId = localStorage.getItem("companyId");
  if (!companyId) return; 

  try {
    let res = await ApiService.get(`/AppSetting/${companyId}`);
    this.themeConfig = res.data;
  } catch (error) {
    console.error("Error", error);
  }
},

    applyTheme() {
      const root = document.documentElement;
      Object.keys(this.themeConfig).forEach((key) => {
          const cssVariableName = `--${key}`;
          root.style.setProperty(cssVariableName, this.themeConfig[key]);
        
      });
    },
    handleNavigation(item) {
      if (item && item.id) {
    const idFolder = item.id; 
    const idCampaign = this.campaignId; 


    ApiService.get(`Journey/GetAppJourney/${idCampaign}?idFolder=${idFolder}`)
      .then((response) => {
        item.children = response.data.blocks; 
        this.itemChildren = item.children; 
      })
      .catch((error) => {
        console.error(` ${idFolder} not found`, error);
      });
  } else {
    console.error("id dont valid.");
  }
},
    getFolderName(idBlockType) {
      const componentsMap = {
        1: "FolderCard",
      };
      return componentsMap[idBlockType] || null;
    },
  raggruppaSurveyPerUtente(array) {
  const surveysBySurveyId = {};

  array.data.forEach((item) => {
    const { id_survey, name_utente_valutato, image_utente_valutato, fine } = item;

    if (!surveysBySurveyId[id_survey]) {
      surveysBySurveyId[id_survey] = {
        id_survey,
        t_nome: item.t_nome,
        fine,
        surveys: [],
      };
    }
    surveysBySurveyId[id_survey].surveys.push({
      id: item.id_utente_valutato,
      name: name_utente_valutato || "Sin nombre",
      image: image_utente_valutato || "URL predeterminada",
      risposte: item.risposte || [], 
    });
  });


  return Object.values(surveysBySurveyId);
},


async getSurveys() {
  this.surveys.splice(0);
  await getMySurveys(229); 
  const groupedSurveys = this.raggruppaSurveyPerUtente(mySurveys.value.data);
  this.surveys = groupedSurveys;
},

    startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    let seconds = 0;
    this.timerInterval = setInterval(() => {
      seconds++;
      const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
      const secs = String(seconds % 60).padStart(2, "0");
      this.timer = `${hrs}:${mins}:${secs}`;
    }, 1000);
  },

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.timer = "00:00:00"; 
  },

    async handleCheckIn() {
     /*  const campaignId = this.$route.params.id; */
      this.isLoading = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: this.$store.getters["user/getUserData"].id,
        idType: 1,
        type: "",
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
        checkin: true,
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);
        this.isCheckInDisabled = true;
        this.isCheckOutDisabled = false;
        this.showTimer = true;
        this.startTimer();
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async handleCheckOut() {
     /*  const campaignId = route.params.id; */
      this.isLoading = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: this.$store.getters["user/getUserData"].id,
        idType: 2,
        type: '',
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);
        this.isCheckInDisabled = false;
        this.isCheckOutDisabled = true;
        this.showTimer = false;
        this.stopTimer();
        /* router.push(`/campaign-journey/${campaignId}/check-in`); */
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },


navigateToNextRoute(item) {
      this.$emit("navigate", item);
    },


  
  },
  async mounted() {
   
    this.getSurveys()
    const store = useStore();
    const route = this.$route;
    const { id } = route.params;
    this.campaignId = id;
    const idUser = store.getters["user/getUserData"].id;
    this.showList1 = false;
    this.showList2 = false;

    ApiService.get(`UserCheckInOut/Gets/0/${idUser}`).then((data) => {
      const lastAction = data.data.sort(
        (a, b) => new Date(b.eventDate) - new Date(a.eventDate)
      )[0];

      if (lastAction) {
        this.lastActionType = lastAction.idType;
      }
    });

    
    ApiService.get(`Journey/GetAppJourney/${id}`).then((data) => {


      const processItems = (items) => {
        return items.blocks.map((item) => ({
          nome: item.nome,
          idBlockType: item.idBlockType,
          blockType: item.blockType,
          children: item.children || [],
          id: item.id,
          learningChapter: item.learningChapter, 
          randomPercentage: Math.floor(Math.random() * 101),
        }));
      };
      this.items = processItems(data.data);


      setTimeout(() => {
        this.$nextTick(() => {
          this.showList1 = true;
        });
      }, 1);

   
    });
    setTimeout(() => {
        this.$nextTick(() => {
          this.showList2 = true;
        });
      }, 1);
      await this.getThemeConfig(); 
      this.applyTheme();
  },
  
};
</script>

<style scoped>
.custom-folder-card {
  background: var(--JCardBg) !important;
}

  .custom-checkinout-card {
    background: #1C1C1C;
    color: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    overflow: hidden;
  }

.badge-text {
  font-size: 14px;
  font-weight: 600;
}



ion-card-header {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.4s ease forwards;
}



@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.timer {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 2rem;
  text-align: center;
  color: white;
}
.btn-check-in {
  background-color: green;
  color: white;
}

.btn-check-out {
  background-color: red;
  color: white;
}

.btn-disabled {
  background-color: lightgray !important;
  cursor: not-allowed;
  opacity: 0.6;
}
.checkinout-button-container  {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.text-20 {
  color: white !important;
}
</style>






